import { render } from "./sidebar.vue?vue&type=template&id=e6364a80"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Web projects\\GRCDOInventory-front-end\\grcdoinventory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__